import { render, staticRenderFns } from "./CadastroEmailTef.vue?vue&type=template&id=1d74cfc2&scoped=true"
import script from "./CadastroEmailTef.vue?vue&type=script&lang=js"
export * from "./CadastroEmailTef.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d74cfc2",
  null
  
)

export default component.exports